import { render, staticRenderFns } from "./EditLocationModal.vue?vue&type=template&id=b3134056&scoped=true"
import script from "./EditLocationModal.vue?vue&type=script&lang=ts"
export * from "./EditLocationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3134056",
  null
  
)

export default component.exports